import { useMemo } from "react";

import { normalizeScoreMatrix } from "../Matrix/utils";
import { ScoreData } from "../types";

const useScoreCards = (
  beforeScore?: ScoreData,
  afterScore?: ScoreData,
  showAll?: boolean,
  currentPage?: number,
) =>
  useMemo(() => {
    if (showAll) {
      const beforeMatrix = normalizeScoreMatrix(beforeScore?.score_matrix);
      const afterMatrix = normalizeScoreMatrix(afterScore?.score_matrix);
      const maxLength = Math.max(beforeMatrix.length, afterMatrix.length);

      return {
        before: beforeMatrix.concat(Array(Math.max(0, maxLength - beforeMatrix.length)).fill([])),
        after: afterMatrix.concat(Array(Math.max(0, maxLength - afterMatrix.length)).fill([])),
      };
    }
    const beforeMatrices = normalizeScoreMatrix(beforeScore?.score_matrix);
    const afterMatrices = normalizeScoreMatrix(afterScore?.score_matrix);
    const page = currentPage || 0;
    return {
      before: [beforeMatrices[page] || []],
      after: [afterMatrices[page] || []],
    };
  }, [beforeScore, afterScore, currentPage, showAll]);

export default useScoreCards;
